import {RETRIEVE_DROP_ROUTE_LIST} from '@/api'
import {CREATE_DROP_ROUTE} from '@/api'
import {GET_DROP_ROUTE_INFO} from '@/api'
import {EDIT_DROP_ROUTE} from '@/api'
import {DELETE_DROP_ROUTE} from '@/api'
import {UPDATE_SCHEDULE_INFO} from '@/api'

export default {
  retrieveDropRouteList({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      // console.log(response);
      if (response.data.data.drop_route_list.length) {
        commit('retrieveDropRouteList', {dropRouteList: response.data.data.drop_route_list})
      }

      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }

    RETRIEVE_DROP_ROUTE_LIST({}, successCallback, errorCallback)
  },

  createDropRoute({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.drop_route_info) {
        // commit('retrievePlaceList', {busList: response.data.data.place_info})
        if (typeof payload.successCallback === 'function') {
          payload.successCallback()
        }
      }
    };

    CREATE_DROP_ROUTE({data: payload.data}, successCallback, errorCallback)
  },

  editDropRoute({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.drop_route_info) {
        if (typeof payload.successCallback === 'function') {
          payload.successCallback()
        }
      }
    };

    EDIT_DROP_ROUTE({data: payload}, successCallback, errorCallback)
  },

  getDropRouteInfo({commit}, payload) {

    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.drop_route_info) {
        commit('getDropRouteInfo', {dropRouteInfo: response.data.data.drop_route_info})
      }
      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }
    GET_DROP_ROUTE_INFO({payload}, successCallback, errorCallback)
  },

  deleteDropRoute({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      commit('deleteDropRoute', {dropRouteInfo: payload})

      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }
    DELETE_DROP_ROUTE({payload}, successCallback, errorCallback)
  },

  didSelectPlace({commit}, payload) {
    commit('didSelectPlace', {dropRouteInfo: payload})
  },
  didSelectBus2({commit}, payload) {
    commit('didSelectBus2', {dropRouteInfo: payload})
  },

  removePlace({commit}, payload) {
    commit('removePlace', {data: payload})
  },
  removeBus({commit}, payload) {
    commit('removeBus', {data: payload})
  },

  addPlace({commit}, payload) {
    commit('addPlace', {})
  },

  addBus({commit}, payload) {
    commit('addBus', {})
  },

  addStudent({commit}, payload) {
    commit('addStudent', {})
  },

  studentSet({commit}, payload) {
    commit('studentSet', payload)
  },

  removeStudent({commit}, payload) {
    commit('removeStudent', payload)
  },

  addSchedule({commit}) {
    commit('addSchedule')
  },

  addPlaceForSchedule({commit}, payload) {
    commit('addPlaceForSchedule', payload)
  },

  addBusForSchedule({commit}, payload) {
    commit('addBusForSchedule', payload)
  },

  removePlaceForSchedule({commit}, payload) {
    commit('removePlaceForSchedule', payload)
  },

  removeBusForSchedule({commit}, payload) {
    commit('removeBusForSchedule', payload)
  },

  removeSchedule({commit}, payload) {
    commit('removeSchedule', payload)
  },

  didSelectWeekDay({commit}, payload) {
    commit('didSelectWeekDay', payload)
  },

  didSelectBus({commit}, payload) {
    commit('didSelectBus', payload)
  },

  updateSchedule({commit}, payload) {

    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data) {
        // commit('getDropRouteInfo', {dropRouteInfo: response.data.data.drop_route_info})
        if (typeof payload.successCallback === 'function') {
          payload.successCallback()
        }
      }

    }
    UPDATE_SCHEDULE_INFO ({payload}, successCallback, errorCallback)
  },
};
